import { scrollToTop } from '@efdigital/ll-xceed-v2/utils/application/scroll.ts';
import type Owner from '@ember/owner';
import type Transition from '@ember/routing/transition';

export function initialize(owner: Owner) {
  const router = owner.lookup('service:router');
  router.on('routeDidChange', (transition: Transition) => {
    if (transition.from?.name !== transition.to?.name) {
      scrollToTop();
    }
  });
}

export default {
  initialize,
};
